/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-01 14:40:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 16:35:04
 */
import ColumnTypes from '@/utils/ColumnTypes';

const descInfo = {
	key: 'descInfo',
	label: '达人信息',
	type: () => import('./descInfo.vue'),
	width: '230',
	className: 'tobeHanded-desc-info',
};
const cooperate_count = {
	key: 'cooperate_count',
	label: '关联合作进度数',
	type: 'rdText',
	minWidth: '120',
};
const sample_count = {
	key: 'sample_count',
	label: '关联样品订单数',
	type: 'rdText',
	minWidth: '120',
};
const cooperate_status_name = {
	key: 'cooperate_status_name',
	label: '跟进状态',
	type: 'rdText',
	minWidth: '130',
};
const authority_id = {
	key: 'authority_id',
	label: '机构ID',
	type: 'rdText',
	minWidth: '150',
};
const shop_name = {
	key: 'shop_name',
	label: '店铺名称',
	type: 'rdText',
	minWidth: '150',
};
export default {
	descInfo,
	cooperate_count,
	sample_count,
	cooperate_status_name,
	authority_id,
	shop_name,
};
